import React from "react";
import InfoCard from "./InfoCard";

const StatCardGroup = ({
  items = [],
  columns = "grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
}) => {
  return (
    <div className={`grid gap-x-6 sm:gap-x-8 md:gap-x-10 lg:gap-x-[52px] gap-y-[30px] ${columns}`}>
      {items.map((item, index) => (
        <InfoCard key={index} label={item.label} value={item.value} />
      ))}
    </div>
  );
};

export default StatCardGroup;
